import Validator from "./Validator";

export default class JsonEntitiesEntityDataContentValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'string',
            empty: false,
            mandatory: false
        };
    }
}
